import styled from 'styled-components';

/**
 * Os seis KPIs numa linha só, que é como o cliente quer ler a faixa.
 *
 * A contagem de colunas é fixa em cada faixa de largura, nunca `auto-fit`:
 * com seis cards o `auto-fit` encaixava cinco na primeira linha e deixava o
 * sexto sozinho embaixo, uma órfã que parecia defeito. As quebras abaixo
 * sempre dividem seis por igual (6 → 3 → 2 → 1), então nenhuma linha fica
 * incompleta.
 *
 * O limiar é baixo (1180px) de propósito. `@media` mede a **viewport**, não a
 * largura que sobra para este grid — o menu lateral e o padding do container
 * comem uns 200px. Num limiar alto a faixa caía para três colunas numa tela
 * que, de fato, ainda comportava as seis.
 *
 * Seis colunas só cabem porque o card encolhe junto; ver `Card`.
 */
export const Container = styled.section`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 0.75rem;

  @media (max-width: 1180px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1rem;
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 560px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const Card = styled.div<{ highlight?: boolean }>`
  background: #fff;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  border: 1px solid ${({ highlight }) => (highlight ? '#FECACA' : 'transparent')};
  display: flex;
  flex-direction: column;
  gap: 0.35rem;

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
  }

  .title {
    font-size: 0.85rem;
    font-weight: 600;
    color: #4b5563;
  }

  .icon {
    color: #4f46e5;
    flex-shrink: 0;
  }

  .value {
    font-size: 1.5rem;
    font-weight: 700;
    color: #111827;
    line-height: 1.2;
    /* Valor longo ("R$ 1.234.567,89") encolhe em vez de estourar a coluna. */
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }

  .caption {
    font-size: 0.75rem;
    color: #6b7280;
  }

  /* Divisão Mesas/Balcão x Delivery, abaixo do total. */
  .split {
    margin: 0.25rem 0 0;
    padding-top: 0.4rem;
    border-top: 1px solid #f3f4f6;
    display: flex;
    flex-direction: column;
    gap: 0.15rem;

    div {
      display: flex;
      justify-content: space-between;
      gap: 0.5rem;
      font-size: 0.75rem;
    }

    dt {
      font-weight: 500;
      color: #6b7280;
      white-space: nowrap;
    }

    dd {
      margin: 0;
      font-weight: 600;
      color: #111827;
      white-space: nowrap;
      font-variant-numeric: tabular-nums;
    }
  }

  /* Faixa dos seis cards lado a lado: o card cede padding e corpo de texto
     para o conteúdo continuar cabendo sem quebrar. */
  @media (min-width: 1181px) {
    padding: 0.875rem 1rem;

    .title {
      font-size: 0.8rem;
    }

    .value {
      font-size: 1.35rem;
    }

    .caption {
      font-size: 0.7rem;
    }
  }
`;
